import React from 'react';
import type { HomeTopicSectionConfig } from '../homeTopicSections';
import {
  isTopicCardLayout,
  resolveItemCardLayout,
  type HomeCardLayout,
} from '../constants/homeCardLayouts';
import { HomeTopicSectionBlock } from './HomeTopicSectionBlock';
import { CmsHomeQuickSection } from './CmsHomeQuickSection';
import { TopicServiceCard } from './TopicServiceCard';

interface CmsFlexibleHomeSectionProps {
  section: HomeTopicSectionConfig;
  sectionIndex: number;
  titleRef?: React.RefObject<HTMLHeadingElement | null>;
  comingSoonSection: string | null;
  onViewAll: () => void;
  onSelect: (categoryId: string, slug: string) => void;
}

function layoutsForSection(section: HomeTopicSectionConfig): HomeCardLayout[] {
  const sectionDefault = section.cardLayout ?? 'topic_cards';
  return section.items.map((item) => resolveItemCardLayout(item.cardLayout, sectionDefault));
}

export const CmsFlexibleHomeSection: React.FC<CmsFlexibleHomeSectionProps> = (props) => {
  const { section, onSelect } = props;
  if (section.items.length === 0) return null;

  const layouts = layoutsForSection(section);
  const allSame = layouts.every((l) => l === layouts[0]);
  const sectionDefault = section.cardLayout ?? 'topic_cards';

  if (allSame && isTopicCardLayout(layouts[0])) {
    return <HomeTopicSectionBlock {...props} />;
  }

  if (allSame && !isTopicCardLayout(layouts[0])) {
    return (
      <CmsHomeQuickSection section={section} layout={layouts[0]} onSelect={onSelect} />
    );
  }

  const quickItems = section.items.filter(
    (item) => !isTopicCardLayout(resolveItemCardLayout(item.cardLayout, sectionDefault))
  );
  const cardItems = section.items.filter((item) =>
    isTopicCardLayout(resolveItemCardLayout(item.cardLayout, sectionDefault))
  );
  const quickLayout = quickItems.length
    ? resolveItemCardLayout(quickItems[0].cardLayout, sectionDefault)
    : sectionDefault;

  return (
    <div>
      <HomeTopicSectionBlock {...props} section={{ ...section, items: [] }} />
      {quickItems.length > 0 && (
        <CmsHomeQuickSection
          section={{ ...section, items: quickItems }}
          layout={quickLayout}
          onSelect={onSelect}
          hideTitle
        />
      )}
      {cardItems.length > 0 && (
        <div className="catalog-grid">
          {cardItems.map((item, index) => (
            <div key={`${item.categoryId}-${item.slug}`} className="catalog-grid-item">
              <TopicServiceCard item={item} index={index} onSelect={onSelect} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
